import {
  Flex,
  IconButton,
  Td,
  Text,
  Tr,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import React from "react";
import { ROOT_API, API_ROUTES } from "utils/constant";
import { axiosPost } from "utils/api";

function WhitelistIpRow({ detail, isLast, refetch }) {
  const textColor = useColorModeValue("gray.500", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const toast = useToast();

  async function handleDelete() {
    if (!window.confirm(`Delete IP ${detail.ip}?`)) return;
    try {
      const res = await axiosPost(ROOT_API + API_ROUTES.IP_DELETE, {
        id: detail._id,
      });
      if (res?.data?.code !== 0) {
        toast({
          title: res?.data?.msg || "Delete failed",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      toast({
        title: "Deleted",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      refetch?.();
    } catch (error) {
      toast({
        title: error?.response?.data?.msg || "Delete failed",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }

  const created = detail.createdAt
    ? new Date(detail.createdAt).toLocaleString()
    : "-";

  return (
    <Tr>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="md" color={textColor} fontWeight="bold">
          {detail.ip}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="sm" color="gray.400">
          {detail.note || "-"}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="sm" color="gray.400">
          {created}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Flex>
          <IconButton
            p={2}
            color="red.400"
            bg="transparent"
            onClick={handleDelete}
            aria-label="Delete IP"
          >
            <DeleteIcon />
          </IconButton>
        </Flex>
      </Td>
    </Tr>
  );
}

export default WhitelistIpRow;
